module.exports = __webpack_public_path__ + "static/media/ic-erro@3x.9b8f6f39.png";